{
  "COMPONENTS": {
    "FILE_BUBBLE": {
      "DOWNLOAD": "Изтегляне",
      "UPLOADING": "Качване..."
    },
    "FORM_BUBBLE": {
      "SUBMIT": "Изпращане"
    },
    "MESSAGE_BUBBLE": {
      "RETRY": "Изпратете съобщението отново",
      "ERROR_MESSAGE": "Неуспешно изпращане, опитайте отново"
    }
  },
  "THUMBNAIL": {
    "AUTHOR": {
      "NOT_AVAILABLE": "Няма информация"
    }
  },
  "TEAM_AVAILABILITY": {
    "ONLINE": "На линия сме",
    "OFFLINE": "В момента не сме на линия",
    "BACK_AS_SOON_AS_POSSIBLE": "Ще се върнем възможно най-скоро"
  },
  "REPLY_TIME": {
    "IN_A_FEW_MINUTES": "Обикновено отговаряме до няколко минути",
    "IN_A_FEW_HOURS": "Обикновено отговаряме до няколко часа",
    "IN_A_DAY": "Обикновено отговаряме до един ден",
    "BACK_IN_HOURS": "Ще бъдем онлайн след {n} час | Ще бъдем онлайн след {n} часа",
    "BACK_IN_MINUTES": "Ще бъдем онлайн след {time} минути",
    "BACK_AT_TIME": "Ще бъдем онлайн в {time}",
    "BACK_ON_DAY": "Ще бъдем онлайн в {day}",
    "BACK_TOMORROW": "Ще бъдем онлайн утре",
    "BACK_IN_SOME_TIME": "Ще бъдем онлайн след известно време"
  },
  "DAY_NAMES": {
    "SUNDAY": "Неделя",
    "MONDAY": "Понеделник",
    "TUESDAY": "Вторник",
    "WEDNESDAY": "Сряда",
    "THURSDAY": "Четвъртък",
    "FRIDAY": "Петък",
    "SATURDAY": "Събота"
  },
  "START_CONVERSATION": "Започнете разговор",
  "END_CONVERSATION": "Приключване на разговора",
  "CONTINUE_CONVERSATION": "Продължете разговора",
  "YOU": "Вие",
  "START_NEW_CONVERSATION": "Започнете нов разговор",
  "VIEW_UNREAD_MESSAGES": "Имате непрочетени съобщения",
  "UNREAD_VIEW": {
    "VIEW_MESSAGES_BUTTON": "Вижте новите съобщения",
    "CLOSE_MESSAGES_BUTTON": "Затвори",
    "COMPANY_FROM": "от",
    "BOT": "Бот"
  },
  "BUBBLE": {
    "LABEL": "Чатете с нас"
  },
  "POWERED_BY": "Осъществено от Chatwoot",
  "EMAIL_PLACEHOLDER": "Моля, въведете имейл адреса си",
  "CHAT_PLACEHOLDER": "Напишете вашето съобщение",
  "TODAY": "Днес",
  "YESTERDAY": "Вчера",
  "PRE_CHAT_FORM": {
    "FIELDS": {
      "FULL_NAME": {
        "LABEL": "Пълно име",
        "PLACEHOLDER": "Моля, въведете пълното си име",
        "REQUIRED_ERROR": "Пълното име е задължително"
      },
      "EMAIL_ADDRESS": {
        "LABEL": "Имейл адрес",
        "PLACEHOLDER": "Моля, въведете имейл адреса си",
        "REQUIRED_ERROR": "Имейл адресът е задължителен",
        "VALID_ERROR": "Моля, въведете валиден имейл адрес"
      },
      "PHONE_NUMBER": {
        "LABEL": "Телефон",
        "PLACEHOLDER": "Моля, въведете вашия телефонен номер",
        "REQUIRED_ERROR": "Телефонният номер е задължителен",
        "DIAL_CODE_VALID_ERROR": "Моля, изберете код на държавата",
        "VALID_ERROR": "Моля, въведете валиден телефонен номер",
        "DROPDOWN_EMPTY": "Няма намерени резултати",
        "DROPDOWN_SEARCH": "Търсене на държава"
      },
      "MESSAGE": {
        "LABEL": "Съобщение",
        "PLACEHOLDER": "Моля, въведете вашето съобщение",
        "ERROR": "Съобщението е прекалено кратко"
      }
    },
    "CAMPAIGN_HEADER": "Преди да започнете разговора, моля, посочете вашето име и имейл адрес",
    "IS_REQUIRED": "е задължително",
    "REQUIRED": "Задължително",
    "REGEX_ERROR": "Моля, въведете валидни данни"
  },
  "FILE_SIZE_LIMIT": "Файлът надхвърля лимита от {MAXIMUM_FILE_UPLOAD_SIZE}",
  "CHAT_FORM": {
    "INVALID": {
      "FIELD": "Невалидно поле"
    }
  },
  "EMOJI": {
    "PLACEHOLDER": "Търсене на емотикони",
    "NOT_FOUND": "Няма намерени емотикони",
    "ARIA_LABEL": "Избор на емотикони"
  },
  "CSAT": {
    "TITLE": "Оценете този разговор",
    "SUBMITTED_TITLE": "Благодарим ви, че оценихте разговора",
    "PLACEHOLDER": "Разкажете ни повече..."
  },
  "EMAIL_TRANSCRIPT": {
    "BUTTON_TEXT": "Поискайте копие от разговора",
    "SEND_EMAIL_SUCCESS": "Копието от разговора бе изпратено успешно",
    "SEND_EMAIL_ERROR": "Възникна грешка, моля опитайте отново"
  },
  "INTEGRATIONS": {
    "DYTE": {
      "CLICK_HERE_TO_JOIN": "Кликнете тук, за да се присъедините",
      "LEAVE_THE_ROOM": "Напускане на разговора"
    }
  },
  "PORTAL": {
    "POPULAR_ARTICLES": "Популярни статии",
    "VIEW_ALL_ARTICLES": "Вижте всички статии",
    "IFRAME_LOAD_ERROR": "Възникна грешка при зареждането на статията, моля опреснете страницата и опитайте отново."
  },
  "ATTACHMENTS": {
    "image": {
      "CONTENT": "Съобщение със снимка"
    },
    "audio": {
      "CONTENT": "Аудио съобщение"
    },
    "video": {
      "CONTENT": "Видео съобщение"
    },
    "file": {
      "CONTENT": "Прикачен файл"
    },
    "location": {
      "CONTENT": "Локация"
    },
    "fallback": {
      "CONTENT": "сподели линк"
    }
  },
  "FOOTER_REPLY_TO": {
    "REPLY_TO": "В отговор на:"
  }
}
